import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Airport } from '../../model/airport.model';
import { AirportService } from '../../service/aiport.service';
import { CoordinateAirportValidatorService } from '../../validator/coordinate-airport-validator.service';

@Component({
  selector: 'app-dropdown-airport-select',
  templateUrl: './dropdown-airport-select.component.html',
  styleUrls: ['./dropdown-airport-select.component.scss']
})
export class DropdownAirportSelectComponent implements OnInit {

  @ViewChild('airportIataCode') airportIataCode: ElementRef;
  @ViewChild('dropdown') dropDown: ElementRef;
  @Output() changeMethod = new EventEmitter<Airport>();

  @Input() airport: Airport;
  @Input() isDefault: boolean;

  form: FormGroup;

  constructor(
    private coordinateAirportValidator: CoordinateAirportValidatorService,
    private airportService: AirportService,
    private renderer: Renderer2
  ) { }

  ngOnInit(): void {
    this.form = new FormGroup({
      airportIataCode: new FormControl(this.airportIataCode,
        {
          validators: [
            Validators.required,
            this.coordinateAirportValidator.exists(false, false, true, null, null, (airport: Airport) => {
              this.setAirport(airport);
            })
          ]
        })
    });
  }

  setAirport(airport: Airport): void {
    if (!this.airport || airport.iataCode !== this.airport.iataCode) {
      if (this.isDefault) {
        this.airportService.setDefaultAirport(airport);
      } else {
        this.changeMethod.next(airport);
      }
      this.renderer.removeClass(this.dropDown.nativeElement, 'show');
    }
  }

  setFocus(): void {
    setTimeout(() => {
      if (this.airport) {
        if (this.airportIataCode !== this.form.get('airportIataCode').value) {
          this.form.get('airportIataCode').setValue(this.airport.iataCode);
        }
      }
      if (this.airportIataCode) {
        this.airportIataCode.nativeElement.focus();
      }
    }, 100);
  }

  changeAirport(airport: string): void{
    if (!airport && this.airport) {
      this.airportService.removeDefaultAirport();
    }
  }

}
